import { useQuery } from "react-query";
import { SusunanKeluargaResponse } from "../../../../models/SusunanKeluarga";
import { getApiInstance } from "../../../api";
import queryWrapper from "../../queryWrapper";
import ApiClient from "../../../apiClient";

export const allSusunanKeluargaOTKey = "all-susunan-keluarga-OT-key";

export async function allSusunanKeluargaOT(): Promise<
  SusunanKeluargaResponse[]
> {
  const res = await ApiClient.get(`/AllKeluargaOT`);
  return res.data;
}

export default function useFetchAllSusunanKeluargaOT() {
  return useQuery(
    [allSusunanKeluargaOTKey],
    queryWrapper(allSusunanKeluargaOT)
  );
}
